<div
  class="promotional-container"
  [@fadeIn]="mappedCards"
  *ngIf="mappedCards.length || showSsoTelehealth"
  [ngClass]="ccss.getClass('benefits')"
>
  <div class="promotional-benefits" ngClass.lt-md="mobile">
    <h2 class="head margin bottom-2x">
      {{ 'promotional_benefits_title' | translate }}
    </h2>
    <!-- Only display SSO telehealth component if telehealth is not enabled by config -->
    <h5 *ngIf="showSubtitle" class="pad bottom-2x">
      {{ 'promotional_benefits_subtitle' | translate }}
    </h5>
    <div
      fxLayout
      fxLayout.lt-md="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.lt-md="stretch"
      fxLayoutGap="16px"
    >
      <div
        [fxFlex.gt-sm]="cardWidth"
        *ngFor="let card of mappedCards; trackBy: trackByFnIndex"
      >
        <app-benefit-card [promotion]="card"></app-benefit-card>
      </div>
    </div>
  </div>
</div>
